import { createSlice,createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import dayjs from 'dayjs'



export const initialState = {
    loading:false,
    visits:[],
    cleanliness:[],
    dateWiseInfo:[]
  }

  export const fetchVisits = createAsyncThunk('visits/fetch', async (sDate)=>{
    try {
        const response =await axios.post(`${process.env.REACT_APP_API_URL}/index.php/api/Users_temp/getDailyTaskDetails` ,{
            selectedDate:sDate
          })
          return response.data.user_daily_tasks
    } catch(err) {
        return err
    }
  })

  export const fetchImageByDateWise = createAsyncThunk('fetchImageByCalendar/fetch', async (info) => {
      try {
        const response =await axios.post(`${process.env.REACT_APP_API_URL}/index.php/api/Users_temp/getDailyTaskImageDetails`,{
        selectedDate: info.sDate,
          task_name:info.tab
        } )
        if(response.data){
            return response.data.daily_tasks
        }
      } catch(err) {
        return err;
      }
     
    })

  export const visitsSlice = createSlice({
    name: 'visits',
	initialState,
	reducers: {
	},
    extraReducers(builder){
        builder
            .addCase(fetchVisits.pending, (state, action) => {
                state.loading = true
            })
            .addCase(fetchVisits.fulfilled, (state, action) => {
                state.loading = false
                state.visits=action.payload
                // Add any fetched posts to the array 
            })
            .addCase(fetchVisits.rejected, (state, action) => {
        
                state.loading = false
            })

            ///

            .addCase(fetchImageByDateWise.pending, (state, action) => {
                state.loading = true
            })
            .addCase(fetchImageByDateWise.fulfilled, (state, action) => {
                state.loading = false
                state.dateWiseInfo=action.payload
                // Add any fetched posts to the array 
            })
            .addCase(fetchImageByDateWise.rejected, (state, action) => {
        
                state.loading = false
            })
    }
  })

  export default visitsSlice.reducer